import { StyledActionWrapper } from 'pages/ApiKeys/columnConfig'
import { StyledClose } from 'pages/Subnets/panels/SubnetApiServie'

import { Check } from 'share-ui/components/Icon/Icons'
import IconButton from 'share-ui/components/IconButton/IconButton'
import Loader from 'share-ui/components/Loader/Loader'
import styled from 'styled-components'
import { useAdminActions } from './useAdminActions'

export const column = ({ pendingTable }: { pendingTable?: boolean }) => {
  return [
    {
      Header: 'Name',
      accessor: 'name',
      minWidth: 100,
      width: 150,
    },
    {
      Header: 'ID',
      accessor: 'id',
      minWidth: 100,
      width: 150,
    },
    {
      Header: 'Account Type',
      accessor: 'account_type',

      minWidth: 40,
      width: 80,
    },

    {
      Header: 'Actions',
      accessor: 'actions',
      minWidth: 50,
      width: 50,

      Cell: (props: { row: { original: any } }) => {
        const { original: data } = props.row

        const { handleActivateAccount, loading, handleDeleteAccount } = useAdminActions()

        return (
          <>
            {loading ? (
              <StyledLoaderWrapper>
                <Loader size={20} />
              </StyledLoaderWrapper>
            ) : (
              <StyledActionWrapper>
                {pendingTable && (
                  <IconButton
                    onClick={() => handleActivateAccount(data.id)}
                    icon={() => <StyledCheckIcon size={24} />}
                    size={IconButton.sizes?.SMALL}
                    kind={IconButton.kinds?.TERTIARY}
                    ariaLabel='Approve'
                  />
                )}

                <IconButton
                  onClick={() => handleDeleteAccount(data.id)}
                  icon={() => <StyledClose size={24} />}
                  size={IconButton.sizes?.SMALL}
                  kind={IconButton.kinds?.TERTIARY}
                  ariaLabel='Delete'
                />
              </StyledActionWrapper>
            )}
          </>
        )
      },
    },
  ]
}

const StyledCheckIcon = styled(Check)`
  fill: ${({ theme }) => theme.body.iconColor};
`
const StyledLoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  height: 100%;
  width: 100%;
`
